export default {
  "translation": {
    "card_application": "カード申請",
    "card_application_des": "Sonicカードを取得し、世界中の44M以上のVisa対応加盟店で使用できます。",
    "spend_your_crypto_like_fiat": "暗号通貨を法定通貨のように使う",
    "use_globally_across_borders": "国境を越えて世界中で使用",
    "ultra_low_trans_costs": "超低取引コスト",
    "seamless_and_secure": "シームレスで安全",
    "two_factor_verification": "二要素認証",
    "two_factor_verification_des": "メール、電話、生体認証、または認証アプリを使用して安全にログイン",
    "safety_pin": "安全PIN",
    "safety_pin_des": "PINを設定して個人情報へのアクセスを制限",
    "trans_3ds_verification": "3DS認証",
    "trans_3ds_verification_des": "処理される前に購入を承認",
    "additional_security": "追加のセキュリティ",
    "additional_security_des": "アプリでカード制限やその他のセキュリティ機能を簡単に設定",
    "get_your_redotpay_card_in_steps": "3つの簡単なステップでSonicカードを取得。",
    "get_your_redotpay_card_subtitle": "暗号資産を法定通貨のように使う：世界中の 44M+ のVisa対応加盟店で利用可能。",
    "continue_key": "続ける",
    "bind_your_mobile_number": "携帯番号をバインド",
    "complete_identity_verification": "本人確認を完了",
    "apply_a_virtual_or_physical_card": "仮想または物理カードを申請",
    "transactions": "取引",
    "need_mobile_bind_confirm": "最初にモバイルをバインドする必要があります",
    "info": "情報",
    "card_trans_status_refund_pending": "返金保留中",
    "card_trans_status_refund_success": "返金成功",
    "card_trans_status_refund_fail": "返金失敗",
    "card_trans_status_refund_wait": "返金待機中",
    "card_trans_status_pending": "承認済み",
    "card_trans_status_cleared": "クリア済み",
    "card_trans_status_declined": "拒否",
    "card_trans_status_canceled": "取り消し済み",
    "card_trans_status_refund": "返金",
    "card_trans_status_refund_cancel": "返金キャンセル",
    "refund": "返金",
    "transaction_list": "取引リスト",
    "more": "もっと",
    "top_questions": "よくある質問",
    "faq": "FAQ",
    "self_service": "セルフサービス",
    "support_center": "サポートセンター",
    "hello": "こんにちは",
    "updated_on": "更新日",
    "chat_with_us": "チャットでお問い合わせ",
    "warning": "警告",
    "security_option_change_alert_prompt": "Google Authenticator/モバイル/メール/PINの解除/変更後、引き出しおよび内部転送が無効になり、カード取引は今後24時間以内に1回の取引につき$1000に制限されます。セキュリティ上の理由から。",
    "cancel": "キャンセル",
    "ok": "OK",
    "account_deletion_regret_promp": "アカウント削除には15日間の後悔期間があります。削除申請後15日以内に再度ログインすると、申請はキャンセルされ、アカウントは通常通り使用できます。",
    "view_on_blockchain_explorer": "ブロックチェーンエクスプローラーで表示",
    "biz_sn": "取引番号",
    "type": "タイプ",
    "create_time": "作成時間",
    "logout_confirm": "本当にログアウトしますか？",
    "wallet": "ウォレット",
    "continue_with_google": "Googleで続行",
    "insufficient_balance_deposit_guide": "残高不足。資産を入金するか、取引が拒否され、手数料が発生する可能性があります。",
    "to": "宛先",
    "bill_will_be_sent_to": "請求書は次の宛先に送信されます",
    "bill_statement": "請求書明細",
    "export_bill": "請求書明細をエクスポート",
    "this_month": "今月",
    "last_month": "先月",
    "last_3_month": "過去3ヶ月",
    "this_year": "今年",
    "last_year": "昨年",
    "customize": "カスタマイズ",
    "bill_export_success": "請求書明細があなたのメールに送信されました。確認してください",
    "bill_empty": "請求書は空です",
    "channel": "チャネル",
    "merchant_country": "加盟店国",
    "status": "ステータス",
    "withdraw_detail": "引き出し詳細",
    "new_key": "新しい",
    "deposit": "入金",
    "withdraw": "引き出し",
    "single_limit": "単一限度",
    "all": "すべて",
    "minimum": "最小",
    "available": "利用可能",
    "received_amount": "受領金額",
    "withdrawl": "引き出し",
    "network_fee": "ネットワーク手数料",
    "register": "登録",
    "register_login": "登録/ログイン",
    "login": "ログイン",
    "email_Phone": "メール/電話番号",
    "email": "メール",
    "mobile": "携帯",
    "next": "次へ",
    "or_continue_with": "または続行",
    "forgot_pw": "パスワードを忘れましたか？",
    "welcome_to_redotpay": "Sonic Payへようこそ",
    "verify_code": "コードを確認",
    "get_code": "コードを取得",
    "by_creating_an_account": "アカウントを作成することで、私たちの",
    "privacy_policy": "プライバシーポリシー",
    "terms_conditions": "利用規約",
    "and": "と",
    "modify_pin": "PINを変更",
    "pin_subtitle": "セキュリティPINは迅速な確認を提供し、カード番号やCVV情報の表示を容易にします。",
    "password_set_first_login": "最初のログイン時にパスワードを設定",
    "next_step": "次のステップ",
    "confirm": "確認",
    "username": "ユーザー名",
    "password": "パスワード",
    "send_code": "コードを送信",
    "send_code_to": "コードは次の宛先に送信されます",
    "switch_option": "認証オプションを変更",
    "mobile_verification": "モバイル認証",
    "email_verification": "メール認証",
    "choose_verify_method": "認証オプションを変更",
    "verify_pin": "セキュリティPIN",
    "google_authenticator_verification": "Google Authenticator",
    "security": "セキュリティ",
    "bound": "バインド済み",
    "unbound": "未バインド",
    "set": "管理",
    "unset": "未設定",
    "update_pw": "パスワード変更",
    "delete_account": "アカウントをキャンセル",
    "google_authenticator": "Google Authenticator",
    "google_authenticator_subtitle": "Google Authenticatorはあなたの引き出しとアカウントを保護します。",
    "download_install": "ダウンロード",
    "download_install_prompt": "最初にAuthenticatorアプリ（Google Authenticator）をダウンロードしてインストールする必要があります。",
    "backup_key": "バックアップキー",
    "save_backup_key": "このバックアップキーを安全な場所に保存してください",
    "google_authenticator_code": "Google Authenticatorコード",
    "email_subtitle": "メール認証はあなたの引き出しとアカウントを保護します。",
    "change_email": "メールを変更",
    "email_update": "メール更新",
    "code": "コード",
    "mobile_subtitle": "モバイル認証はあなたの引き出しとアカウントを保護します。",
    "change_mobile": "モバイルを変更",
    "mobile_update": "モバイル更新",
    "mobile_bind": "モバイル電話をバインド",
    "email_bind": "メールをバインド",
    "old_password": "旧パスワード",
    "new_password": "新しいパスワード",
    "new_password_confirm": "新しいパスワード確認",
    "language": "言語",
    "appearance": "外観",
    "logout": "ログアウト",
    "log_out_toast": "ログアウトしました",
    "set_pin": "セキュリティPIN",
    "account_deletion_prompt_1": "このアカウントは決して復元できません",
    "account_deletion_prompt_2": "このアカウントによって作成されたすべてのサブユーザー/他のアカウントは削除され、復元できません。",
    "account_deletion_prompt_3": "このアカウントに関連付けられたすべてのAPIキーが削除されます。",
    "account_deletion_prompt_4": "このアカウントのすべての現在の委任および保留中の通貨引き出しがキャンセルされます。",
    "account_deletion_prompt_5": "このアカウントのすべての取引機能が無効になります。",
    "account_deletion_prompt_6": "このアカウントから引き出されない資産は、自発的に放棄された資産と見なされます。",
    "account_deletion_prompt_7": "アカウント削除申請後、15日間の引き出し期間があります。削除リクエスト後15日以内に再度ログインすると、リクエストはキャンセルされ、アカウントは通常通り使用できます。",
    "kyc_status_0": "未提出",
    "kyc_status_1": "確認中...",
    "kyc_status_2": "承認済み",
    "kyc_status_3": "審査失敗",
    "kyc_status_4": "再提出",
    "kyc_status_5": "上流に提出",
    "personal_info_review": "個人情報レビュー",
    "additional_info_request": "追加情報のリクエスト",
    "verifying": "確認中...",
    "form_submitted_will_review_asap_new": "あなたの申請は手動レビューのために提出されました。通常、プロセスには3〜5日かかりますが、時にはそれ以上かかることもあります。ご辛抱ください。",
    "get_verified": "本人確認",
    "kyc_verified": "ユーザーの本人確認済み",
    "approved": "承認済み",
    "not_able_to_submit_identity": "包括的な審査プロセスの一環として、顧客確認（KYC）およびマネーロンダリング防止（AML）審査手続きを完了するために、追加情報が必要です。",
    "aml_review_failed": "申請を続行するには、以下のボタンをクリックして自己申告書を記入してください。",
    "aml_declaration_prompt": "要求された書類を次の14日以内に提供しないと、申請が却下されることにご注意ください。",
    "verify_your_identity": "あなたの身元を確認",
    "get_identity_verified": "カードを購入して使用するために身元を確認してください",
    "country_region": "国/地域",
    "given_name": "名",
    "surname": "姓",
    "date_of_birth": "生年月日",
    "document_type": "書類タイプ",
    "document_number": "書類番号",
    "given_name_intl": "名（国際）",
    "surname_intl": "姓（国際）",
    "click_to_add_signature": "署名を追加するにはクリック",
    "rewrite": "再記入",
    "submit": "提出",
    "save": "保存",
    "accounts_are_not_available": "アカウントは利用できません",
    "abandon_assets": "{{amount}} {{currency}}の資産を放棄",
    "account_deletion_successful": "アカウント削除成功",
    "passwords_do_not_match": "パスワードが一致しません",
    "password_reset_success": "パスワードリセット成功",
    "password_confirm": "パスワード確認",
    "is_refund": "返金",
    "total_debt": "総負債",
    "your_account_is_in_arrears": "あなたのアカウントは滞納中です。残高を清算するために十分な資金を入金してください。残高が10ドル以上になると、アカウント/カードが復元されます。",
    "repayment": "返済",
    "debit_record": "デビット記録",
    "no_data": "データなし",
    "payment": "支払い",
    "transaction_details": "取引詳細",
    "transaction_date": "取引日",
    "transaction_id": "取引ID",
    "view_linked_order": "リンクされた注文を見る",
    "rights_interests": "権利と利益",
    "transaction_limit": "取引制限",
    "deposit_withdraw": "入金と引き出し",
    "card_purchased_number": "購入可能なカードの数",
    "on_review_your_applicant": "あなたの申請をレビュー中です",
    "form_en_only": "このフォームは英語でのみ記入できます",
    "available_to_spend": "使用可能",
    "get_a_card": "Sonicカードを取得し、世界中の44M以上のVisa対応加盟店で使用できます。",
    "virtual_card": "仮想カード",
    "physical_card": "物理カード",
    "apply_card": "カードを申請",
    "enjoy_seamless_spending": "支出を楽しむ",
    "spend_and_withdraw": "支出とATM引き出し",
    "card_labeling": "カードラベリング",
    "card_tag": "カードタグ",
    "edit_billing_address": "請求先住所",
    "government_issued_id": "政府発行のID",
    "facial_recognition": "顔認証",
    "address": "住所",
    "personnel_information_details": "個人情報の詳細",
    "nation_list": "国リスト",
    "choose_channel": "認証モード",
    "mobile_channel_sms": "SMS",
    "mobile_channel_smsAliyunWhatsApp": "WhatsAPP",
    "card_application_order": "カード申請順序",
    "promo_code_optional": "プロモーションコード（任意）",
    "promo_code": "プロモーションコード",
    "billing_address": "請求先住所",
    "shipping_address": "配送先住所",
    "shipping_to": "配送先",
    "card_purchase_fee": "カード購入手数料",
    "card_holder_name": "カード名義人名",
    "city": "市",
    "province_state": "州/県",
    "postal_code": "郵便番号/ZIP",
    "address_line1": "住所",
    "address_line2": "住所ライン2",
    "please_fill_in_the_information_in_english": "このフォームは英語でのみ記入できます",
    "first_name": "名",
    "last_name": "姓",
    "country_code": "国コード",
    "card_application_list": "カード申請リスト",
    "buy_virtual_card": "仮想カードを購入",
    "buy_physical_card": "物理カードを購入",
    "withdraw_list": "引き出しリスト",
    "no_more_data": "これ以上のデータはありません",
    "select_a_network": "ネットワークを選択",
    "please_select_network": "ネットワークを選択してください",
    "select_a_network_ensure": "選択した入金ネットワークが引き出しネットワークと一致することを確認してください。さもなければ、資産が失われる可能性があります。",
    "network": "ネットワーク",
    "card_management": "カード管理",
    "freeze": "凍結",
    "unfreeze": "解除",
    "freeze_card_des": "ワンクリックカードロック機能が有効になると、このカードは使用できなくなりますが、他のカードには影響しません。ワンクリックカードロック機能をキャンセルしたい場合は、ここで再度有効にできます。",
    "freezing_trades": "カードを凍結すると、失敗した注文が発生し、取引の失敗や拒否された取引に追加料金がかかることがあります。",
    "unfreeze_your_card_desc": "ワンクリックカードロック機能が無効になると、このカードを再び使用できるようになります。他のカードには影響しません。カードを凍結したい場合は、ここで再度行えます。",
    "card_tag_set_success": "カードタグの設定が成功しました",
    "bill": "請求書",
    "setting": "設定",
    "limit": "制限",
    "assets_list": "資産リスト",
    "empty_data": "データなし",
    "deposit_list": "入金リスト",
    "date": "日付",
    "merchant_city": "商人の都市",
    "card_number": "カード番号",
    "card_type": "カードタイプ",
    "mcc": "MCC",
    "declined_reason": "拒否理由",
    "card_authorization_payment": "カード承認支払い",
    "declined_transaction_fee": "拒否された取引手数料",
    "verified": "確認済み",
    "notifications": "通知",
    "need_to_add_bill_address": "請求先住所を追加する必要があります",
    "need_to_add_shipping_address": "配送先住所は空にできません",
    "success": "成功",
    "welcome_redotpay": "Sonic Payへようこそ！",
    "reset_pw_alert": "パスワード変更後、引き出しと内部転送が無効になり、次の24時間はカード取引が1回あたり$1000に制限されます。",
    "no_more_records": "これ以上の記録はありません",
    "add": "追加",
    "address_label": "住所ラベル",
    "add_address": "住所を追加",
    "this_field_is_required": "このフィールドは必須です",
    "ID_CARD": "身分証明書",
    "PASSPORT": "パスポート",
    "DRIVERS": "運転免許証",
    "RESIDENCE_PERMIT": "居住許可証",
    "amount": "金額",
    "withdraw_status_waiting": "待機中",
    "withdraw_status_pending": "保留中",
    "withdraw_status_success": "成功",
    "withdraw_status_fail": "失敗",
    "withdraw_status_canceled": "キャンセル",
    "withdraw_status_declined": "拒否",
    "withdraw_status_complete": "完了",
    "order_id": "注文ID",
    "click_or_scroll_to_load_more": "クリックまたはスクロールしてさらに読み込む",
    "minimum_deposit_amount": "最小入金額",
    "deposit_arrival_confirmations": "入金到着: {{confirmations}} 確認",
    "confirmations": "{{confirmations}} 確認",
    "deposit_network": "入金ネットワーク",
    "minimum_deposit": "最小入金",
    "deposit_arrival": "入金到着",
    "current_address_supports_depositing": "現在のアドレスは{{varietyCode}}の入金のみをサポートしており、他の資産は失われます。",
    "copy_successful": "コピー成功",
    "update_password_successful": "パスワード更新成功",
    "update_successful": "更新成功",
    "successful": "成功",
    "signature_required": "署名が必要",
    "deposit_successful": "入金成功",
    "sign_out": "ログアウト",
    "cancel_withdraw_order_success": "引き出し注文のキャンセルが成功しました",
    "delete_successful": "削除成功",
    "unfreeze_card_successful": "カードの解除が成功しました",
    "card_nickname_set_success": "カードのニックネーム設定が成功しました",
    "trans_limit_adjusted_success": "取引制限の調整が成功しました",
    "set_card_pin_success": "カードPINの設定が成功しました",
    "withdraw_apply_commit_please_wait": "引き出し申請が提出されました。お待ちください",
    "unfreeze_success": "解除成功",
    "freeze_success": "凍結成功",
    "withdraw_duration_tip": "引き出し申請は1営業日以内に処理されます",
    "you_will_withdraw": "あなたは引き出します",
    "withdraw_info": "引き出し情報",
    "please_confirm_same_network": "選択した入金ネットワークが入金ネットワークと一致することを確認してください。さもなければ、資産が失われる可能性があります。",
    "cancel_withdraw_order_confirm": "引き出しをキャンセルしてもよろしいですか？",
    "valid_thru": "有効期限",
    "last_7_days": "過去7日間",
    "last_30_days": "過去30日間",
    "today": "今日",
    "all_done": "すべて完了",
    "view_details": "詳細を見る",
    "withdraw_success": "引き出し成功",
    "pay": "支払う",
    "fee": "手数料",
    "discount": "割引",
    "price": "価格",
    "card_application_details": "カード申請詳細",
    "card_pin": "カードPIN",
    "card_pin_format_helper": "3つ以上の連続した同じ数字や連続する数字を含むことはできません",
    "digit_variable": "{{count}}桁",
    "address_book": "アドレス帳",
    "unlimited": "無制限",
    "single": "単一",
    "update_card_pin": "カードPINを更新",
    "set_card_pin": "カードPINを設定",
    "report_lost": "紛失報告",
    "report_lost_card": "紛失したカードを報告",
    "card_lost_report_alert": "紛失を報告すると、カードは無効になり、そのステータスを変更することはできません。カードを再使用したり新しいカードを申請する場合は、カスタマーサービスに連絡してください。",
    "pending": "保留中",
    "frozen": "凍結",
    "phone_number": "電話番号",
    "search": "検索",
    "reset": "リセット",
    "total_amount": "合計金額",
    "actual_amount": "実際の金額",
    "already_have_an_account": "すでにアカウントをお持ちですか？",
    "create_account": "Sonic Payアカウントを作成",
    "total_balance": "総残高",
    "cards_balance_available_promp": "クレジット限度額はウォレット資産に基づいてリアルタイムで計算されます",
    "got_it": "了解しました",
    "review_details": "詳細をレビュー",
    "delete_this_address": "この住所を削除してもよろしいですか？",
    "currency": "通貨",
    "merchant_name": "商人名",
    "request_time": "リクエスト時間",
    "is_transaction_allowed": "この取引は許可されていますか？",
    "approve": "承認",
    "decline": "拒否",
    "card_in_production": "カード製作中",
    "redotpay_card_sent": "Redotpayカード送付済み",
    "redotpay_card_activated": "Redotpayカード有効化済み",
    "activate_card": "カードを有効化",
    "paste": "貼り付け",
    "fees_included": "含まれる手数料",
    "fx_fee": "FX手数料",
    "small_auth_fee": "小額取引手数料",
    "atm_fee": "ATM手数料",
    "received": "受け取った",
    "incremental": "インクリメンタル",
    "bill_address_save_success": "請求書宛先の保存に成功しました",
    "no_more_trans_record": "取引記録はありません",
    "withdraw_amount_larger_than_available": "最大利用可能残高を超えています",
    "withdraw_lower_than_min": "最低引き出し額を下回っています",
    "card_is_deleted": "カードは削除されました",
    "something_error": "何かがおこりませんでした",
    "home": "ホーム",
    "select_country": "国を選択",
    "billing_list": "請求書一覧",
    "coupon_code": "割引コード",
    "password_rule1": "8文字から32文字まで",
    "password_rule2": "英語の大文字少なくとも1つ",
    "password_rule3": "英語の小文字少なくとも1つ",
    "password_rule4": "数字少なくとも1つ",
    "set_pw": "パスワードを設定",
    "payment_currency_settings": "支払い通貨設定",
    "customize_payment_currency": "支払い通貨をカスタマイズ",
    "disable_non_local_tip": "非現地通貨の取引を無効化することで、カード詐欺のリスクを効果的に軽減できます",
    "charging_rules": "課金ルール",
    "reissue_card": "カードの再発行",
    "update_cvv": "CVVコードを更新",
    "update_cvv_desc": "同じカード番号で新しいCVVコードと有効期限。",
    "reissue_fee": "再発行手数料",
    "fx_fee_desc": "外国為替手数料（FX手数料）には、1.2%の非デフォルト通貨取引手数料が含まれます。（該当する場合）",
    "atm_fee_desc": "ATMでの引き出しごとに追加料金2%が課されます。",
    "remit_fee_desc": "Visaクレジットカードまたはデビットカードを使用する際の手数料。",
    "risk_safety_tips": "安全のヒント",
    "risk_safety": "セキュリティ上の理由から、関連操作を進める前にアプリで顔認証を完了してください。",
    "go_to_app_verify": "アプリで認証を行う",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "RedotPayへ移行する",
    "close": "閉じる",
    "card_cancellation": "カードのキャンセル",
    "delete_card": "カードを削除",
    "delete_card_desc": "削除後、カードは使用できなくなり、この操作は元に戻せません。",
    "deleting_fee": "削除手数料",
    "currency_tips": "通貨のヒント",
    "at_least_one_currency": "少なくとも1つの支払い可能な通貨を保持してください。",
    "all_select_currency": "すべての通貨がすでに取引に対応しています。",
    "small_auth_transaction_fee_stas": "小額取引手数料の詳細",
    "small_transactions_this_month": "今月の小額取引",
    "small_autn_trans_remain": "今月の小額取引免除回数",
    "rules": "ルール",
    "failed_rules": "取引失敗は不良取引記録を増加させ、超過すると追加料金が発生します。取引を適切に行ってください。",
    "rule_item": "項目",
    "free_count": "無料回数",
    "fees": "手数料",
    "declined_trans_remain": "今月の拒否取引免除回数",
    "declined_transaction_fee_stats": "拒否取引手数料の統計",
    "declined_rules": "取引失敗は不良取引記録を増加させ、超過すると追加料金が発生します。取引を適切に行ってください。",
    "declined_transactions_this_month": "今月の拒否取引回数",
    "card_trans_detail_status_refund": "返金処理中",
    "card_trans_status_reversal": "取消し",
    "card_trans_status_fully_refund": "処理済み、全額返金",
    "card_trans_status_partial_refund": "処理済み、一部返金",
    "card_trans_status_void": "無効",
    "first_time_free": "初回無料",
    "FxFee": "外国為替手数料",
    "AtmFee": "ATM手数料",
    "RemitFee": "送金手数料",
    "MccFee": "MCC手数料",
    "mcc_fee_desc": "一部の加盟店では取引金額の1.5%の追加料金が課されます。料金が0.5 USD未満の場合、最低0.5 USDの料金が適用されます。",
    "please_deposit": "入金してください",
    "special_mcc_fee": "特別MCC手数料",
    "bank_verifying": "この返金は銀行が確認中です…",
    "estimate_time": "入金予定日: 2～30日",
    "delete_out": "ログアウト",
    "card_is_loss": "カードが紛失報告されています",
    "incremental_desc": "承認金額が不足している場合、追加料金が発生し、該当金額は精算時に加算されます。",
    "card_trans_status_fully_refund1": "精算済み",
    "card_trans_status_fully_refund2": "全額返金",
    "card_trans_status_partial_refund1": "精算済み",
    "card_trans_status_partial_refund2": "一部返金",
    "review_takes_time": "レビューには 2 分から 24 時間かかります。",
    "custom_date_null": "カスタム日付を選択してください",
    "custom_date_error": "正しいクエリ時間を設定してください",
    "small_trade_fee": "小さな取引手数料",
    "user_risk_exception": "ユーザー状態の例外",
    "request_exception": "リクエストエラー",
    "mobile_is_not_empty": "正しい携帯電話番号を入力してください",
    "code_is_not_empty": "正しい確認コードを入力してください",
    "browser_paste_error": "ブラウザの制限のため、手動で入力してください"
  }
};